import React, { Component } from 'react';
import moment from 'moment';
import { BarChart, LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar, Line, ResponsiveContainer } from 'recharts';
import { Row, Col, Card, CardTitle, CardBody } from 'reactstrap';

import './Reportes.css';
import ExpandableCard from './ExpandableCard';
import ParadigmaAsyncSeeker from '../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker';
import ParadigmaDatePicker from '../../components/ParadigmaDatePicker/ParadigmaDatePicker';
import ParadigmaLabeledInput from '../../components/ParadigmaLabeledInput/ParadigmaLabeledInput';
import api from '../../api/api';
import functions from '../../api/functions';

class Reportes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ventasPorLoteo: [],
            gastosIngresos: [],
            gastosIngresosDolares: [],
            consultas: [],
            ventasVendedor: [],
            lotesDisponibles: [],
            deudaProveedores: [],
            filtros: {
                desde: moment().subtract(1, 'year'),
                hasta: moment(),
                loteo_id: null,
                vendedor_id: null,
            },
            costosGanancias: ['costos', 'ganancia'],
            costosGananciasOrderBy: 'ganancia',
            viajesVendidos: 0
        }
    }

    componentDidMount() {
        this.fetch();
    }

    fetch = () => {
        const { desde, hasta, vendedor_id, loteo_id } = this.state.filtros;

        let filters = [];
        if (desde) filters.push(`from=${desde.format('YYYY-MM-DD')}`);
        if (hasta) filters.push(`to=${hasta.format('YYYY-MM-DD')}`);
        if (vendedor_id) filters.push(`vendedor=${vendedor_id}`);
        if (loteo_id) filters.push(`loteo=${loteo_id}`);

        functions.get(api.reportes.reportes, null, null, { filters }, resp => {
            this.setState({
                ventasPorLoteo: resp.data.ventasPorLoteo.map(venta => ({ ...venta, month: this.parseDate(venta.month, venta.year), year: undefined })),
                gastosIngresos: resp.data.gastosIngresos.map(gastos => ({ ...gastos, month: this.parseDate(gastos.month, gastos.year), year: undefined })),
                gastosIngresosDolares: resp.data.gastosIngresosDolares.map(gastos => ({ ...gastos, month: this.parseDate(gastos.month, gastos.year), year: undefined })),
                consultas: resp.data.consultas.map(venta => ({ ...venta, month: this.parseDate(venta.month, venta.year), year: undefined })),
                ventasVendedor: resp.data.ventasVendedor,
                lotesDisponibles: resp.data.lotesDisponibles,
                deudaProveedores: resp.data.deudaProveedores,
            });
        })
    }

    parseDate = (month, year) => {
        return moment(`${month} ${year}`, "MM YYYY").format('MMM YY');
    }

    render() {
        const { desde, hasta } = this.state.filtros;
        return (
            <div className="reportes px-2 py-2">
                <Row className="m-0">
                    <Col className="col-12">
                        <Card body className="border-0 p-0 mb-3">
                            <CardTitle className="text-center py-2 mb-0 col-color">Filtros</CardTitle>
                            <CardBody>
                                <Row>
                                    <Col className="col-12 col-md-4">
                                        <ParadigmaLabeledInput
                                            label="Período"
                                            md={[3, 9]}
                                            inputComponent={
                                                <Row>
                                                    <Col className="col-6 col-md-12 col-lg-12 col-xl-6 mb-0 mb-md-1 mb-xl-0 pr-1">
                                                        <ParadigmaDatePicker fieldName={"fechaInicio"}
                                                            datetime={false}
                                                            placeholder={"Desde"}
                                                            icon={"fa fa-calendar"}
                                                            value={this.state.filtros.desde}
                                                            onChange={data => this.setState(prevState => ({
                                                                filtros: {
                                                                    ...prevState.filtros,
                                                                    desde: data
                                                                }
                                                            }), this.fetch)}
                                                        />
                                                    </Col>
                                                    <Col className="col-6 col-md-12 col-lg-12 col-xl-6 pl-1">
                                                        <ParadigmaDatePicker fieldName={"fechaFin"}
                                                            datetime={false}
                                                            placeholder={"Hasta"}
                                                            icon={"fa fa-calendar"}
                                                            value={this.state.filtros.hasta}
                                                            onChange={data => this.setState(prevState => ({
                                                                filtros: {
                                                                    ...prevState.filtros,
                                                                    hasta: data
                                                                }
                                                            }), this.fetch)}
                                                        />
                                                    </Col>
                                                </Row>
                                            }
                                        />
                                    </Col>
                                    <Col className="col-12 col-md-4">
                                        <ParadigmaLabeledInput
                                            label="Vendedor"
                                            md={[3, 9]}
                                            inputComponent={
                                                <ParadigmaAsyncSeeker
                                                    //url={api.usuarios.usuarios}
                                                    url={api.vendedores.usuarios}
                                                    nombreField="apellido_nombre"
                                                    displayField="apellido_nombre"
                                                    value={this.state.filtros.vendedor_id}
                                                    parameters={{
                                                        paginationEnabled:false,
                                                    }}
                                                    onChange={data => this.setState(prevState => ({
                                                        filtros: {
                                                            ...prevState.filtros,
                                                            vendedor_id: data ? data.id : null
                                                        }
                                                    }), this.fetch)}
                                                />
                                            }
                                        />
                                    </Col>
                                    <Col className="col-12 col-md-4">
                                        <ParadigmaLabeledInput
                                            label="Loteos"
                                            md={[3, 9]}
                                            inputComponent={
                                                <ParadigmaAsyncSeeker
                                                    url={api.loteos.loteos}
                                                    value={this.state.filtros.loteo_id}
                                                    parameters={{
                                                        paginationEnabled:false,
                                                       sort:['nombre'],
                                                    }}
                                                    onChange={data => this.setState(prevState => ({
                                                        filtros: {
                                                            ...prevState.filtros,
                                                            loteo_id: data ? data.id : null
                                                        }
                                                    }), this.fetch)}
                                                />
                                            }
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>

                    <ExpandableCard title="Ventas Mensuales">
                        <ResponsiveContainer width={'100%'} height={250}>
                            <BarChart data={this.state.ventasPorLoteo}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="month" type="category" />
                                <YAxis type="number" allowDecimals={false} />
                                <Tooltip />
                                <Legend />
                                <Bar name="Ventas" dataKey="ventas" stackId="month" fill="#ffc107" />
                            </BarChart>
                        </ResponsiveContainer>
                    </ExpandableCard>

                    <ExpandableCard title="Ventas por Vendedor">
                        <ResponsiveContainer width={'100%'} height={250}>
                            <BarChart data={this.state.ventasVendedor}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="nombre_vendedor" type="category" />
                                <YAxis type="number" allowDecimals={false} />
                                <Tooltip />
                                <Legend />
                                <Bar name="Ventas" dataKey="ventas" stackId="month" fill="#ffc107" />
                            </BarChart>
                        </ResponsiveContainer>
                    </ExpandableCard>

                    <ExpandableCard title="Gastos e Ingresos">
                        <ResponsiveContainer width={'100%'} height={250}>
                            <LineChart width={730} height={250} data={this.state.gastosIngresos}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="month" type="category" />
                                <YAxis type="number" />
                                <Tooltip />
                                <Legend />
                                <Line name="Gastos" type="monotone" dataKey="gastos" stroke="#8884d8" strokeWidth={3} />
                                <Line name="Ingresos" type="monotone" dataKey="ingresos" stroke="#82ca9d" strokeWidth={3} />
                            </LineChart>
                        </ResponsiveContainer>
                    </ExpandableCard>

                    <ExpandableCard title="Gastos e Ingresos (en Dolares)">
                        <ResponsiveContainer width={'100%'} height={250}>
                            <LineChart width={730} height={250} data={this.state.gastosIngresosDolares}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="month" type="category" />
                                <YAxis type="number" />
                                <Tooltip />
                                <Legend />
                                <Line name="Gastos" type="monotone" dataKey="gastos" stroke="#8884d8" strokeWidth={3} />
                                <Line name="Ingresos" type="monotone" dataKey="ingresos" stroke="#82ca9d" strokeWidth={3} />
                            </LineChart>
                        </ResponsiveContainer>
                    </ExpandableCard>

                    <ExpandableCard title="Consultas y Ventas">
                        <ResponsiveContainer width={'100%'} height={250}>
                            <LineChart width={730} height={250} data={this.state.consultas}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="month" type="category" />
                                <YAxis type="number" />
                                <Tooltip />
                                <Legend />
                                <Line name="Consultas" type="monotone" dataKey="consultas" stroke="#8884d8" strokeWidth={3} />
                                <Line name="Ventas" type="monotone" dataKey="ventas" stroke="#82ca9d" strokeWidth={3} />
                            </LineChart>
                        </ResponsiveContainer>
                    </ExpandableCard>

                    <ExpandableCard title="Tipos de Unidades disponibles">
                        <ResponsiveContainer width={'100%'} height={250}>
                            <BarChart data={this.state.lotesDisponibles}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="descripcion" type="category" />
                                <YAxis allowDecimals={false} />
                                <Tooltip />
                                <Legend />
                                <Bar name="Disponibles" dataKey="disponibles" stackId="descripcion" fill="#4dbd74" />
                                <Bar name="No disponibles" dataKey="no_disponibles" stackId="descripcion" fill="#f86c6b" />
                            </BarChart>
                        </ResponsiveContainer>
                    </ExpandableCard>

                    <ExpandableCard title="Deuda de Proveedores">
                        <ResponsiveContainer width={'100%'} height={250}>
                            <BarChart data={this.state.deudaProveedores}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="proveedor__nombre" type="category" />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                <Bar name="Disponibles" dataKey="saldo" fill="#f86c6b" />
                            </BarChart>
                        </ResponsiveContainer>
                    </ExpandableCard>

                </Row>
            </div>
        );
    }
}

export default Reportes;



// WEBPACK FOOTER //
// ./src/views/Reportes/Reportes.js